import { takeEvery, call } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'

import { RecordBulkUpdateAction, RECORD_BULK_UPDATE } from './actions'

function* editRecordBulkUpdateSaga(action: RecordBulkUpdateAction) {
  const {
    accountId,
    projectId,
    moduleName,
    fieldName,
    newValue,
    recordIds,
    showSuccessNotification,
    showFailureNotification
  } = action
  try {
    yield call(() =>
      axios
        .put(
          `/accounts/${accountId}/projects/${projectId}/modules/${moduleName}/bulk-update`,
          {
            fieldName,
            newValue,
            recordIds
          },
          {
            validateStatus: status => {
              if (status === 200 || status === 201 || status === 204) {
                return true
              }
              return false
            }
          }
        )
        .then(response => {
          showSuccessNotification(response.data)
        })
    )
  } catch (error) {
    console.log('Error bulk update of records:', error)
    showFailureNotification()
  }
}

export function* watch() {
  yield takeEvery(RECORD_BULK_UPDATE, editRecordBulkUpdateSaga)
}
